module.exports = __webpack_public_path__ + "img/es.8e0fff5a.svg";